(function () {
  'use strict';

  var DOUBLY_COOKIE_NAME = window.__DOUBLY_COOKIE_NAME__ || '_g1776869440';

  var USER_CURRENCY_KEY = 'beast_currency_user_choice_v1';
  var USER_CURRENCY_COOKIE = 'beast_currency_user_choice_v1';

  var DEFAULT_MARKER_KEY = 'beast_currency_default_marker_v1';
  var DEFAULT_MARKER_COOKIE = 'beast_currency_default_marker_v1';

  var lastCurrencyInteractionAt = 0;
  var patchTimer = null;

  var EU_COUNTRIES = {
    AT: true,
    BE: true,
    BG: true,
    HR: true,
    CY: true,
    CZ: true,
    DK: true,
    EE: true,
    FI: true,
    FR: true,
    DE: true,
    GR: true,
    HU: true,
    IE: true,
    IT: true,
    LV: true,
    LT: true,
    LU: true,
    MT: true,
    NL: true,
    PL: true,
    PT: true,
    RO: true,
    SK: true,
    SI: true,
    ES: true,
    SE: true
  };

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
    );

    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function encodeCurrency(currency) {
    try {
      return btoa(currency);
    } catch (e) {
      return currency;
    }
  }

  function decodeCurrency(value) {
    try {
      return atob(value);
    } catch (e) {
      return value;
    }
  }

  function normalizeCurrency(value) {
    var raw;
    var decoded;
    var match;

    if (!value) return '';

    raw = String(value).trim();

    if (/^[A-Za-z]{3}$/.test(raw)) {
      return raw.toUpperCase();
    }

    decoded = decodeCurrency(raw);

    if (/^[A-Za-z]{3}$/.test(decoded)) {
      return decoded.toUpperCase();
    }

    match = String(raw).toUpperCase().match(/\b[A-Z]{3}\b/);

    if (match && match[0]) {
      return match[0];
    }

    match = String(decoded).toUpperCase().match(/\b[A-Z]{3}\b/);

    if (match && match[0]) {
      return match[0];
    }

    return '';
  }

  function safeLocalStorageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function safeLocalStorageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }

  function getSavedUserCurrency() {
    return normalizeCurrency(safeLocalStorageGet(USER_CURRENCY_KEY)) || normalizeCurrency(getCookie(USER_CURRENCY_COOKIE));
  }

  function saveUserCurrency(currency) {
    var normalizedCurrency = normalizeCurrency(currency);

    if (!normalizedCurrency) return;

    safeLocalStorageSet(USER_CURRENCY_KEY, normalizedCurrency);
    setCookie(USER_CURRENCY_COOKIE, normalizedCurrency, 180);
  }

  function clearDefaultMarker() {
    safeLocalStorageRemove(DEFAULT_MARKER_KEY);
    setCookie(DEFAULT_MARKER_COOKIE, '', -1);
  }

  function getDefaultMarker() {
    var raw = safeLocalStorageGet(DEFAULT_MARKER_KEY) || getCookie(DEFAULT_MARKER_COOKIE);

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function setDefaultMarker(currency, marketGroup) {
    var marker = JSON.stringify({
      currency: currency,
      marketGroup: marketGroup
    });

    safeLocalStorageSet(DEFAULT_MARKER_KEY, marker);
    setCookie(DEFAULT_MARKER_COOKIE, marker, 180);
  }

  function isUkraineContext() {
    var marketHandle = String(window.__SHOPIFY_MARKET_HANDLE__ || '').toLowerCase();
    var countryCode = String(window.__SHOPIFY_COUNTRY_CODE__ || '').toUpperCase();
    var pathname = String(window.location.pathname || '').toLowerCase();

    return (
      marketHandle === 'ukraine' ||
      marketHandle === 'ua' ||
      marketHandle.indexOf('ukraine') !== -1 ||
      countryCode === 'UA' ||
      pathname === '/uk-ua' ||
      pathname.indexOf('/uk-ua/') === 0 ||
      pathname === '/ua' ||
      pathname.indexOf('/ua/') === 0
    );
  }

  function isEuropeContext() {
    var marketHandle = String(window.__SHOPIFY_MARKET_HANDLE__ || '').toLowerCase();
    var countryCode = String(window.__SHOPIFY_COUNTRY_CODE__ || '').toUpperCase();
    var pathname = String(window.location.pathname || '').toLowerCase();

    if (EU_COUNTRIES[countryCode]) return true;

    if (
      marketHandle === 'eu' ||
      marketHandle === 'europe' ||
      marketHandle === 'european-union' ||
      marketHandle.indexOf('europe') !== -1 ||
      marketHandle.indexOf('euro') !== -1
    ) {
      return true;
    }

    return (
      pathname === '/eu' ||
      pathname.indexOf('/eu/') === 0 ||
      pathname.indexOf('/en-eu') === 0 ||
      pathname.indexOf('/de-eu') === 0 ||
      pathname.indexOf('/fr-eu') === 0 ||
      pathname.indexOf('/es-eu') === 0 ||
      pathname.indexOf('/it-eu') === 0
    );
  }

  function getMarketGroup() {
    if (isUkraineContext()) return 'UA';
    if (isEuropeContext()) return 'EU';

    return 'US';
  }

  function getDefaultCurrencyByMarketGroup(marketGroup) {
    if (marketGroup === 'UA') return 'UAH';
    if (marketGroup === 'EU') return 'EUR';

    return 'USD';
  }

  function readDoublyCookieCurrency() {
    var appCurrency;
    var cookieValue;

    try {
      if (
        window.DoublyGlobalCurrency &&
        window.DoublyGlobalCurrency.cookie &&
        typeof window.DoublyGlobalCurrency.cookie.read === 'function'
      ) {
        appCurrency = normalizeCurrency(window.DoublyGlobalCurrency.cookie.read());

        if (appCurrency) {
          return appCurrency;
        }
      }
    } catch (e) {}

    cookieValue = getCookie(DOUBLY_COOKIE_NAME);

    return normalizeCurrency(cookieValue);
  }

  function getWantedCurrencyData() {
    var savedUserCurrency = getSavedUserCurrency();
    var marketGroup = getMarketGroup();
    var defaultCurrency = getDefaultCurrencyByMarketGroup(marketGroup);
    var defaultMarker = getDefaultMarker();
    var currentDoublyCurrency = readDoublyCookieCurrency();

    if (savedUserCurrency) {
      return {
        currency: savedUserCurrency,
        source: 'user',
        marketGroup: marketGroup
      };
    }

    if (currentDoublyCurrency) {
      if (
        defaultMarker &&
        defaultMarker.currency === currentDoublyCurrency &&
        defaultMarker.marketGroup &&
        defaultMarker.marketGroup !== marketGroup
      ) {
        return {
          currency: defaultCurrency,
          source: 'default',
          marketGroup: marketGroup
        };
      }

      return {
        currency: currentDoublyCurrency,
        source: 'cookie',
        marketGroup: marketGroup
      };
    }

    return {
      currency: defaultCurrency,
      source: 'default',
      marketGroup: marketGroup
    };
  }

  function writeRawDoublyCookie(currency) {
    var normalizedCurrency = normalizeCurrency(currency);

    if (!normalizedCurrency) return;

    setCookie(DOUBLY_COOKIE_NAME, encodeCurrency(normalizedCurrency), 30);
  }

  function writeDoublyCurrency(currency) {
    var normalizedCurrency = normalizeCurrency(currency);

    if (!normalizedCurrency) return;

    window.__beastCurrencyInternalWrite = true;

    try {
      if (
        window.DoublyGlobalCurrency &&
        window.DoublyGlobalCurrency.cookie &&
        typeof window.DoublyGlobalCurrency.cookie.write === 'function'
      ) {
        window.DoublyGlobalCurrency.cookie.write(normalizedCurrency);
      } else {
        writeRawDoublyCookie(normalizedCurrency);
      }
    } catch (e) {
      writeRawDoublyCookie(normalizedCurrency);
    }

    setTimeout(function () {
      window.__beastCurrencyInternalWrite = false;
    }, 50);
  }

  function applyDoublyCurrencyAfterLoad() {
    var wantedCurrencyData = getWantedCurrencyData();
    var targetCurrency = wantedCurrencyData.currency;
    var currentCurrency = readDoublyCookieCurrency();

    if (!targetCurrency) return;

    if (currentCurrency !== targetCurrency) {
      writeDoublyCurrency(targetCurrency);
    }

    if (wantedCurrencyData.source === 'default') {
      setDefaultMarker(targetCurrency, wantedCurrencyData.marketGroup);
    }

    try {
      if (!window.DoublyGlobalCurrency) return;

      if (typeof window.DoublyGlobalCurrency.convertAll === 'function') {
        window.DoublyGlobalCurrency.convertAll(targetCurrency);
      }

      if (typeof window.doublyChangeEvent === 'function') {
        window.doublyChangeEvent();
      }
    } catch (e) {}
  }

  function isCurrencyWidgetElement(node) {
    while (node && node !== document) {
      if (
        node.name === 'doubly-currencies' ||
        (node.classList && node.classList.contains('doubly-wrapper')) ||
        (node.classList && node.classList.contains('doubly-nice-select')) ||
        (node.classList && node.classList.contains('doubly-float'))
      ) {
        return true;
      }

      node = node.parentNode;
    }

    return false;
  }

  function findCurrencyFromNode(node) {
    var value;
    var currency;

    while (node && node !== document) {
      value =
        node.value ||
        (node.getAttribute && node.getAttribute('data-value')) ||
        (node.getAttribute && node.getAttribute('data-currency')) ||
        node.textContent;

      currency = normalizeCurrency(value);

      if (currency) {
        return currency;
      }

      node = node.parentNode;
    }

    return '';
  }

  function persistCurrencyFromDoublyCookie() {
    var currency = readDoublyCookieCurrency();

    if (!currency) return;

    if (Date.now() - lastCurrencyInteractionAt < 5000) {
      saveUserCurrency(currency);
      clearDefaultMarker();
    }
  }

  function schedulePersistCurrencyFromDoublyCookie() {
    setTimeout(persistCurrencyFromDoublyCookie, 80);
    setTimeout(persistCurrencyFromDoublyCookie, 250);
    setTimeout(persistCurrencyFromDoublyCookie, 700);
  }

  function patchDoublyCookieWrite() {
    var originalWrite;

    if (!window.DoublyGlobalCurrency || !window.DoublyGlobalCurrency.cookie) {
      return false;
    }

    if (window.__beastDoublyCookieWritePatched) {
      return true;
    }

    if (typeof window.DoublyGlobalCurrency.cookie.write !== 'function') {
      return false;
    }

    originalWrite = window.DoublyGlobalCurrency.cookie.write;

    window.DoublyGlobalCurrency.cookie.write = function (currency) {
      var normalizedCurrency = normalizeCurrency(currency);
      var result = originalWrite.apply(this, arguments);

      if (
        !window.__beastCurrencyInternalWrite &&
        normalizedCurrency &&
        Date.now() - lastCurrencyInteractionAt < 5000
      ) {
        saveUserCurrency(normalizedCurrency);
        clearDefaultMarker();
      }

      return result;
    };

    window.__beastDoublyCookieWritePatched = true;

    return true;
  }

  function startPatchWatcher() {
    var tries = 0;

    if (patchTimer) return;

    patchTimer = setInterval(function () {
      tries++;

      if (patchDoublyCookieWrite() || tries > 40) {
        clearInterval(patchTimer);
        patchTimer = null;
      }
    }, 250);
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      var selectedCurrency;

      if (!target || target.name !== 'doubly-currencies') return;

      selectedCurrency = normalizeCurrency(target.value);

      if (!selectedCurrency) return;

      lastCurrencyInteractionAt = Date.now();

      saveUserCurrency(selectedCurrency);
      clearDefaultMarker();

      schedulePersistCurrencyFromDoublyCookie();

      setTimeout(applyDoublyCurrencyAfterLoad, 80);
      setTimeout(applyDoublyCurrencyAfterLoad, 300);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var clickedCurrency;

      if (!event.target || !isCurrencyWidgetElement(event.target)) return;

      lastCurrencyInteractionAt = Date.now();

      clickedCurrency = findCurrencyFromNode(event.target);

      if (clickedCurrency) {
        saveUserCurrency(clickedCurrency);
        clearDefaultMarker();
      }

      schedulePersistCurrencyFromDoublyCookie();
    },
    true
  );

  var initialWantedCurrencyData = getWantedCurrencyData();

  if (initialWantedCurrencyData && initialWantedCurrencyData.currency) {
    if (readDoublyCookieCurrency() !== initialWantedCurrencyData.currency) {
      writeRawDoublyCookie(initialWantedCurrencyData.currency);
    }

    if (initialWantedCurrencyData.source === 'default') {
      setDefaultMarker(initialWantedCurrencyData.currency, initialWantedCurrencyData.marketGroup);
    }
  }

  startPatchWatcher();

  document.addEventListener('DOMContentLoaded', function () {
    patchDoublyCookieWrite();

    setTimeout(applyDoublyCurrencyAfterLoad, 100);
    setTimeout(applyDoublyCurrencyAfterLoad, 500);
    setTimeout(applyDoublyCurrencyAfterLoad, 1500);
  });

  window.addEventListener('load', function () {
    patchDoublyCookieWrite();

    setTimeout(applyDoublyCurrencyAfterLoad, 100);
    setTimeout(applyDoublyCurrencyAfterLoad, 700);
  });
})();